/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFlujosEtapas from './entidades/flujosEtapas';
import IFlujosEtapasCompuesta from './entidades/flujosEtapasCompuesta';
import IFlujosEtapasFiltros from './entidades/flujosEtapasFiltros';

export default class ModeloFlujosEtapas {
    public consultarFlujosEtapas() {
        return manejadorRest<IRespuesta<IFlujosEtapas>>(
            () => negocioConfiguracion.get('FlujosEtapas/ConsultarListaFlujosEtapas'),
            true
        );
    }

    public consultarFlujosEtapasCompuesta() {
        return manejadorRest<IRespuesta<IFlujosEtapasCompuesta>>(
            () => negocioConfiguracion.get('FlujosEtapas/ConsultarListaFlujosEtapasCompuesta'),
            true
        );
    }

    public consultaFlujosEtapasCompuestaPorFiltro(filtros: IFlujosEtapasFiltros) {
        return manejadorRest<IRespuesta<IFlujosEtapasCompuesta>>(
            () => negocioConfiguracion.post('FlujosEtapas/ConsultaFlujoEtapasCompuestaPorFiltro', filtros),
            true
        );
    }

    public crearFlujosEtapas(flujosEtapas: IFlujosEtapas) {
        return manejadorRest<IRespuesta<IFlujosEtapas>>(
            () => negocioConfiguracion.post('FlujosEtapas/GuardarFlujosEtapas', flujosEtapas),
            true
        );
    }

    public editarFlujosEtapas(flujosEtapas: IFlujosEtapas) {
        return manejadorRest<IRespuesta<IFlujosEtapas>>(
            () => negocioConfiguracion.put('FlujosEtapas/EditarFlujosEtapas', flujosEtapas),
            true
        );
    }

    public eliminarFlujosEtapas(flujosEtapas: IFlujosEtapas) {
        return manejadorRest<IRespuesta<IFlujosEtapas>>(
            () => negocioConfiguracion.delete('FlujosEtapas/EliminarFlujosEtapas', flujosEtapas),
            true
        );
    }
}
